import { ToastContainer } from "react-toastify";
import { SectionDivider } from "./components/SectionDivider";
import { CountDown } from "./sections/CountDown";
import { Details } from "./sections/Details";
import { Footer } from "./sections/Footer";
import { Form } from "./sections/Form/indes";
import { Intro } from "./sections/Intro";

function App() {
  return (
    <div className="App">
      <Intro />

      <CountDown />

      <SectionDivider from="white" to="secondary-light" />

      <Details />

      <Form />

      <Footer />

      <ToastContainer
        theme="colored"
        autoClose={1500}
        position="bottom-center"
        limit={1}
        toastStyle={{
          color: "var(--color-primary-text)",
          fontWeight: "bold",
          backgroundColor: "var(--color-secondary-light)",
        }}
        toastClassName="justify-center"
        closeOnClick
      />
      <div id="confetti" className="fixed bottom-30 w-1/1 h-0"></div>
    </div>
  );
}

export default App;
